// returns an int representing the relation type has with parameter t

function getRelation(x, y) {
    var r = 0;
    var a = [0, 0];
    var b = [0, 0];
    a = x.getSerialNumbers();
    b = y.getSerialNumbers();
    var a1 = a[0];
    var a2 = a[1];
    var b1 = b[0];
    var b2 = b[1];

    //pretend we are comparing to ISTP
    if (a1 % 10 === b1 % 10) { //_i both are introverted
        if (Math.floor(a1 / 100) === Math.floor(b1 / 100)) { //both are judging. Ti or Fi
            if (Math.floor(a1 / 10) % 10 === Math.floor(b1 / 10) % 10) { // both are thinking Ti
                if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) 
                {r = 2;} // both are sensing TiSe
                else r = 5; //TiNe
            } else { // Fi
                if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 6;} //FiSe
                else r = 9; //FiNe
            }
        } else { //Ni or Si
            if (Math.floor(a2 / 10) % 10 === Math.floor(b1 / 10) % 10) { //Si
                if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 14;} //thinking, SiTe
                else r = 11; //SiFe
            } else { //Ni
                if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 10;} //thinking, NiTe
                else r = 3; //NiFe
            }
        }
    } else { //_e one is extraverted
        if (Math.floor(a1 / 100) === Math.floor(b1 / 100)) { //both are judging. Te or Fe
            if (Math.floor(a1 / 10) % 10 === Math.floor(b1 / 10) % 10) { // both are thinking Te
                if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 4;} // both are sensing TeSi
                else r = 13; //TeNi
            } else { // Fe
                if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 12;} //FeSi
                else r = 16; //FeNi
            }
        } else { //Ne or Se
            if (Math.floor(a2 / 10) % 10 === Math.floor(b1 / 10) % 10) { //Se
                if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 15;} //thinking, SeTi
                else r = 7; //SeFi //n
            } else { //Ni
                if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 8;} //thinking, NeTi
                else r = 1; //NeFi
            }
        }
    }
    return r;
}

export { getRelation }
// //pretend we are comparing to ISTP
// if (a1 % 10 === b1 % 10) { //_i both are introverted
//     if (Math.floor(a1 / 100) === Math.floor(b1 / 100)) { //both are judging. Ti or Fi
//         if (Math.floor(a1 / 10) % 10 === Math.floor(b1 / 10) % 10) { // both are thinking Ti
//             if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) 
//             {r = 2;} // both are sensing TiSe
//             else r = 5; //TiNe
//         } else { // Fi
//             if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 6;} //FiSe
//             else r = 9; //FiNe
//         }
//     } else { //Ni or Si
//         if (Math.floor(a2 / 10) % 10 === Math.floor(b1 / 10) % 10) { //Si
//             if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 14;} //thinking, SiTe
//             else r = 11; //SiFe
//         } else { //Ni
//             if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 10;} //thinking, NiTe
//             else r = 3; //NiFe
//         }
//     }
// } else { //_e one is extraverted
//     if (Math.floor(a1 / 100) === Math.floor(b1 / 100)) { //both are judging. Te or Fe
//         if (Math.floor(a1 / 10) % 10 === Math.floor(b1 / 10) % 10) { // both are thinking Te
//             if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 15;} // both are sensing TeSi
//             else r = 8; //TeNi
//         } else { // Fe
//             if (Math.floor(a2 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 7;} //FeSi
//             else r = 1; //FeNi
//         }
//     } else { //Ne or Se
//         if (Math.floor(a2 / 10) % 10 === Math.floor(b1 / 10) % 10) { //Se
//             if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 4;} //thinking, SeTi
//             else r = 12; //SeFi
//         } else { //Ni
//             if (Math.floor(a1 / 10) % 10 === Math.floor(b2 / 10) % 10) {r = 13;} //thinking, NeTi
//             else r = 16; //NeFi
//         }
//     }
// }